import { CoreInterfaces, DTOs } from "./../../core/Models";
import * as Constants from "./../../core/Constants";

export function formEngagementVersionDTO(
  item: CoreInterfaces.EngagementVersionReadPack
): DTOs.EngagementVersionDTO {
  return {
    data: {
      createdBy: item.CreatedBy,
      createdDate: item.CreatedDate,
      description: item.Description,
      engagementConfigurationId: item.EngagementConfigurationId,
      version: item.Version,
      signingStatus: item.SigningStatus,
      signingDate: item.SigningDate,
      status: item.Status,
    },
    state: {
      isSelected: false,
      isDisabled: false,
      canBeDeleted:
        item.SigningStatus !== Constants.SigningStatus.DigitallySigned &&
        item.SigningStatus !== Constants.SigningStatus.ManuallySigned,
    },
  };
}

export function formEmployee(
  employeeReadPack: CoreInterfaces.BEEmployee
): CoreInterfaces.Employee {
  if (employeeReadPack) {
    const object: CoreInterfaces.Employee = {
      Id: null,
      FirstName: employeeReadPack.FirstName,
      LastName: employeeReadPack.LastName,
      Email: employeeReadPack.Email,
      UID: employeeReadPack.UID,
      Office: employeeReadPack.Office,
      BusinessUnit: employeeReadPack.BusinessUnit,
    };
    return object;
  }
  return null;
}

export function formBEEmployee(
  employee: CoreInterfaces.Employee
): CoreInterfaces.BEEmployee {
  if (employee) {
    const object: CoreInterfaces.BEEmployee = {
      FirstName: employee.FirstName,
      LastName: employee.LastName,
      Email: employee.Email,
      UID: employee.UID,
      Office: employee.Office,
      BusinessUnit: employee.BusinessUnit,
      JobName: employee.JobName,
    };
    return object;
  }
  return null;
}

export function formBEEmployeeFromContactPersonItem(
  employee: CoreInterfaces.ContactPersonItem
): CoreInterfaces.BEEmployee {
  if (employee) {
    const object: CoreInterfaces.BEEmployee = {
      FirstName: employee.firstName,
      LastName: employee.lastName,
      Email: employee.email,
      UID: employee.key,
      Office: employee.office,
      BusinessUnit: employee.businessUnit,
      JobName: employee.jobName,
    };
    return object;
  }
  return null;
}

export function formContactPersonItemFromBEEmployee(
  beEmployee: CoreInterfaces.BEEmployee
): CoreInterfaces.ContactPersonItem {
  if (beEmployee) {
    const object: CoreInterfaces.ContactPersonItem = {
      firstName: beEmployee.FirstName,
      lastName: beEmployee.LastName,
      email: beEmployee.Email,
      key: beEmployee.UID,
      office: beEmployee.Office,
      businessUnit: beEmployee.BusinessUnit,
      value: null,
      jobName: beEmployee.JobName,
      GTSignee: undefined,
    };
    return object;
  }
  return null;
}
